import React from 'react';
import PropTypes from 'prop-types';
import './ItemMRPInfo.scss';

const ItemMRPInfo = ({
  discountPercent,
  listPriceDecimal,
  salePriceDecimal,
  quantity,
  omsEnabled,
  isCart,
  isGradedDiscountApplicable,
}) => {
  if (salePriceDecimal === 0) {
    return <div className="ItemMRPInfo">To be updated</div>;
  }

  if (omsEnabled && quantity === 0) {
    // eslint-disable-next-line no-param-reassign
    quantity = 1;
  }

  const calculatedListPriceDecimal = Number(omsEnabled ? listPriceDecimal / quantity : listPriceDecimal).toFixed(2);
  // const calculatedSalePriceDecimal = Number(omsEnabled ? salePriceDecimal / quantity : salePriceDecimal).toFixed(2);
  const calculatedTotalPrice = omsEnabled ? Number(salePriceDecimal) : Number(salePriceDecimal * quantity).toFixed(2);

  if (isCart && isGradedDiscountApplicable) {
    return (<div className="ItemMRPInfo">
      { (salePriceDecimal > 0) && <span className="listPrice">MRP ₹{calculatedListPriceDecimal}</span> }
      { (salePriceDecimal > 0) && (quantity > 0) && <span className="discountPercent">₹{calculatedTotalPrice}</span> }
      { (discountPercent > 0) && <span className="discountPercent">Save({discountPercent}%)</span> }
    </div>);
  }

  if (isGradedDiscountApplicable) {
    return (<div className="ItemMRPInfo">
      { (salePriceDecimal > 0) && <span className="listPrice">MRP ₹{calculatedListPriceDecimal}</span> }
      { (discountPercent > 0) && <span className="discountPercent">Upto {discountPercent}%*</span> }
      { (salePriceDecimal > 0) && (quantity > 0) && <span className="discountPercent">₹{calculatedTotalPrice}</span> }
    </div>);
  }

  return (<div className="ItemMRPInfo">
    { (salePriceDecimal > 0) && <span className="listPrice">MRP ₹{calculatedListPriceDecimal}</span> }
    {<span className="discountPercent">Save {discountPercent}%</span> }
    { (salePriceDecimal > 0) && (quantity > 0) && <span className="discountPercent">₹{calculatedTotalPrice}</span> }
  </div>);
};

ItemMRPInfo.propTypes = {
  discountPercent: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  listPriceDecimal: PropTypes.string,
  salePriceDecimal: PropTypes.string,
  quantity: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  omsEnabled: PropTypes.bool,
  isGradedDiscountApplicable: PropTypes.bool,
  isCart: PropTypes.bool,
};

ItemMRPInfo.defaultProps = {
  discountPercent: 0,
  listPriceDecimal: '0',
  salePriceDecimal: '0',
  quantity: 0,
  omsEnabled: false,
  isGradedDiscountApplicable: false,
  isCart: false,
};

export default ItemMRPInfo;
